// import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
// import { FaCcMastercard } from "react-icons/fa6";
import { ImArrowUp } from "react-icons/im";
import { Events, animateScroll as scroll, scrollSpy } from 'react-scroll';
import { useEffect } from 'react';

function Footer() {
    const handleSetActive = (to: any) => {
        // console.log(to)
        scroll.scrollToTop()
    };
    useEffect(() => {

        // Registering the 'begin' event and logging it to the console when triggered.
        Events.scrollEvent.register('begin', (to, element) => {
            console.log('begin', to, element);
        });

        // Registering the 'end' event and logging it to the console when triggered.
        Events.scrollEvent.register('end', (to, element) => {
            console.log('end', to, element);
        });

        // Updating scrollSpy when the component mounts.
        scrollSpy.update();

        // Defining functions to perform different types of scrolling.
        // const scrollToTop = () => {
        //   scroll.scrollToTop();
        // };

        // const scrollToBottom = () => {
        //   scroll.scrollToBottom();
        // };

        // const scrollTo = () => {
        //   scroll.scrollToTop(100); // Scrolling to 100px from the top of the page.
        // };

        // const scrollMore = () => {
        //   scroll.scrollMore(100); // Scrolling an additional 100px from the current scroll position.
        // };

        // Function to handle the activation of a link.

        // Returning a cleanup function to remove the registered events when the component unmounts.
        return () => {
            Events.scrollEvent.remove('begin');
            Events.scrollEvent.remove('end');
        };
    }, [])


    return (

        <Container className='footer__content'>

            <div onClick={handleSetActive}>
                <ImArrowUp className='footer__content__arrow-up' style={{ fontSize: '5rem', height: '50px', margin: '1rem' }} />
            </div>
            <Row className="footer__content__brand-row mb-4">
                <Col >
                    <div className="footer__content__footer-text">

                        <img src="/mindfield-logo-new.jpg" alt="cube" height="65px" style={{ marginLeft: "1.25rem", margin: "1rem 0", display: 'inline' }}></img>
                        <Card.Title style={{ margin: '1rem', fontSize: '15px' }}>© 2025 Mindfield Creations. All rights reserved.</Card.Title>
                        {/* <span> support@mindfield-creations.com</span> */}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md={8}>

                    {/* <FaStripe style={{ fontSize: '5rem', height: '50px', margin: '1rem' }} /> */}
                    {/* <FaAws style={{ fontSize: '5rem', height: '50px', margin: '1rem' }} />
                    <FaGoogle style={{ fontSize: '5rem', height: '50px', margin: '1rem' }} />
                    <FaPython style={{ fontSize: '5rem', height: '50px', margin: '1rem' }} />
                    <SiTypescript style={{ fontSize: '5rem', height: '50px', margin: '1rem' }} />
                    <FaNodeJs style={{ fontSize: '5rem', height: '50px', margin: '1rem' }} />
                    <RiVisaLine style={{ fontSize: '5rem', height: '50px', margin: '1rem' }} />
                    <FaCcPaypal style={{ fontSize: '5rem', height: '50px', margin: '1rem' }} /> */}
                </Col>
                <Col md={4}>
                    <div style={{ visibility: 'visible' }}>
                        admin@mindfield-creations.com
                    </div>
                    <div style={{ visibility: 'hidden' }}>
                        Disclaimer
                    </div>
                    <div style={{ fontSize: '15px', visibility: 'hidden' }}>
                        admin@mindfield-creations.com
                    </div>
                </Col>
                <Col md={4}>

                    {/* <div>
                        Privacy Policy
                    </div>
                    <div>
                        Email: admin@mindfield-creations.com
                    </div>
                    <div>
                        Disclaimer
                    </div> */}
                </Col>
                <Col md={4}>

                    {/*    <div>
                        Privacy Policy
                    </div>
                    <div>
                        Email: support@mindfield-creations.com
                    </div>
                    <div>
                        Disclaimer
                    </div> */}
                </Col>
            </Row>

            {/* <Row>
                <Col md={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img src={require('./mindfield-cube.png')} alt="cube" height="65px" style={{ marginLeft: "1.2rem", display: 'inline' }}></img>
                    2025 Mindfield Creations. All rights reserved.
                </Col>

            </Row> */}

        </Container>
    );
}

export default Footer;